import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { FN_GENERATION__update_locally } from '../_methods/FN_GENERATION__update_locally';
import { STATE__generation } from '../STATE__generation';

export const REMOTE__generation_update_tool = createAsyncThunkSafe<void, DTO__generation_tool>(
  ENUM__network_event_client_to_server.GENERATION_UPDATE_TOOL,
  async (graph: DTO__generation_tool): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.GENERATION_UPDATE_TOOL, graph);
  },
);

export function INIT_REMOTE__generation_update_tool(builder: ActionReducerMapBuilder<STATE__generation>) {
  builder
    .addCase(REMOTE__generation_update_tool.pending, (state, action) => {
      let tool = action.meta.arg;
      FN_GENERATION__try_update_generation_tool(state, tool);
    })
    .addCase(REMOTE__generation_update_tool.rejected, (state, action) => {})
    .addCase(REMOTE__generation_update_tool.fulfilled, (state, action: PayloadAction) => {});
}

function FN_GENERATION__try_update_generation_tool(state: STATE__generation, tool: DTO__generation_tool) {
  if (state.generation_current._id != tool.generation_id) return;

  let generation_current = state.generation_current.clone();

  generation_current.tool = tool.clone();

  //clone needs to force rerender generation current
  FN_GENERATION__update_locally(state, generation_current);
}
